interface SurveyProps {
    fill?: string;
}

function Survey({fill = 'currentColor'}: SurveyProps) {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                stroke={fill}
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M11.667 13.667a2 2 0 0 0 4 0V2.333a2 2 0 0 0-4 0zM6 13.667a2 2 0 0 0 4 0v-4a2 2 0 1 0-4 0zM.333 13.667a2 2 0 1 0 4.001 0 2 2 0 0 0-4 0"
            />
  </svg>
);
}

export default Survey;
